import { DashboardLicenseResponseArray } from './dashboard.license.response';
import { InvoiceItem } from './invoice.item';

export interface IDashboardProductsResponse {

    MemberID: number;
    FirstName: string;
    LastName: string;
    Email: string;
    IsMember: boolean;
    Desginers: DashboardProductsResponseArray;
    Licenses: DashboardLicenseResponseArray;
    SharedGISCredits: number;
    PersonalGISCredits: number;
    IsTOS: boolean;
    IsDispute: boolean;
    IsFormerTOS: boolean;
    IsGrace: boolean;
    GraceInvoice: InvoiceItem;
    InitFromJSON();

}

export class DashboardProductsResponse implements IDashboardProductsResponse {

    MemberID: number;
    FirstName: string;
    LastName: string;
    Email: string;
    IsMember: boolean;
    Desginers: DashboardProductsResponseArray;
    Licenses: DashboardLicenseResponseArray;
    SharedGISCredits: number;
    PersonalGISCredits: number;
    IsTOS: boolean;
    IsDispute: boolean;
    IsFormerTOS: boolean;
    IsGrace: boolean;
    GraceInvoice: InvoiceItem;

    InitFromJSON() {

        if (this.Licenses != undefined) {
            Object.setPrototypeOf(this.Licenses, DashboardLicenseResponseArray.prototype);
            this.Licenses.InitFromJSON();
        }

        if (this.Desginers != undefined) {
            Object.setPrototypeOf(this.Desginers, DashboardProductsResponseArray.prototype);
            this.Desginers.InitFromJSON();
        }

    }

}


export class DashboardProductsResponseArray extends Array<DashboardProductsResponse> {

    constructor(...items: DashboardProductsResponse[]) {
        super(...items);
        Object.setPrototypeOf(this, DashboardProductsResponseArray.prototype);
    }

    public InitFromJSON() {

        if (this.length == 0)
            return;

        this.forEach((item) => {

            if (item.Licenses != undefined && item.Licenses.length > 0) {
                Object.setPrototypeOf(item.Licenses, DashboardLicenseResponseArray.prototype);
                item.Licenses.InitFromJSON();
            }

        })
    }

}